'use client';

import { type PropsWithChildren, useMemo, useRef, useState } from 'react';
import { CarouselContext, CarouselDispatchContext } from './CarouselContext';

export const CarouselProvider = ({ children }: PropsWithChildren) => {
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const trackRef = useRef<HTMLUListElement | null>(null);

  return (
    <CarouselContext.Provider
      value={useMemo(() => ({ atStart, atEnd, trackRef }), [atStart, atEnd])}
    >
      <CarouselDispatchContext.Provider
        value={useMemo(() => ({ setAtStart, setAtEnd }), [setAtStart, setAtEnd])}
      >
        {children}
      </CarouselDispatchContext.Provider>
    </CarouselContext.Provider>
  );
};
